export default __webpack_public_path__ + "static/block2-658da60535da758b4714a67887bee51d.png";